import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import styled from '@emotion/styled';

const containerBaseStyles = ({ theme }) => css`
  border: 2px solid ${theme.colors.n700};
  border-radius: ${theme.borderRadius.circle};
  width: 20px;
  height: 20px;
`;

const containerActiveStyles = ({ theme, isActive }) =>
  isActive &&
  css`
    border-color: ${theme.colors.red};
  `;

const Container = styled('div')`
  ${containerBaseStyles};
  ${containerActiveStyles};
`;

const innerCircleBaseStyles = ({ theme, isActive }) =>
  isActive &&
  css`
    border: 3px solid ${theme.colors.white};
    background-color: ${theme.colors.red};
    border-radius: ${theme.borderRadius.circle};
    width: 16px;
    height: 16px;
  `;

const InnerCircle = styled('div')`
  ${innerCircleBaseStyles};
`;

const Radio = ({ isActive }) => (
  <Container isActive={isActive}>
    <InnerCircle isActive={isActive} />
  </Container>
);

Radio.propTypes = {
  isActive: PropTypes.bool,
};

Radio.defaultProps = {
  isActive: false,
};

export default Radio;
